<template>
  <div class="listing">
    <tips class="listing-tip">
      <div class="listing-tip__line"> 1. 以下信息仅针对“亚马逊各Listing商品”在不同供应链环节下的对应数量（可以简单理解为不同供应链环节下的库存量：包括生产中数量，国内中转仓库存数量，国际运输中数量，亚马逊仓的库存量等）； </div>
      <div class="listing-tip__line"> 2. 以下的“Listing商品总库量”,“生产中数量”,“国内中转仓库存量”,“国际运输中数量”等仅限“亚马逊的商品信息”（注意区别“仓储/库存状况/总库存量”中的“总库存量”除了“亚马逊的商品信息”外,还有“非亚马逊的商品信息”(例如: 储备的产品库存,待定的亚马逊商品); </div>
      <div class="listing-tip__line"> 3."生产中数量","国内中转仓库存数量","国际运输入中数量"按本系统的"进销存数据及物流订单数据"即时反映真实数据; "亚马逊仓可售库量"仅记录"汇总数据报告"上传当天的即时库存数量; "汇总数据报告"最新统计周期为: </div>
    </tips>
    <div class="listing-top">
      <div class="listing-top__name">亚马逊商品库存量</div>
      <div class="listing-top__fun">
        <div class="listing-top-item">
          <div class="listing-top-item__name">国家站点:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="listing-top-item">
          <div class="listing-top-item__name">店铺:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="listing-top-item listing-top-item--input">
          <el-input size="mini" placeholder="请输入产品名称,型号,ASIN,SKU等"></el-input>
        </div>
        <div class="listing-top__btn">搜索</div>
        <div class="listing-top__btn">创建盘点单</div>
      </div>
    </div>
    <div class="listing-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { StockStatusSearchData, StockStatusNewMoodule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'amazonProductInventory',
  components: {
    Table, tips
  },
  data(){
    return {
      searchData: new StockStatusSearchData(),
      TableHead: StockStatusNewMoodule.NEWLISTINGTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.listing{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
